import type { ReactNode } from 'react';
import type { HostingServerView } from '@tosho/contracts';
import { PrototypeIcon } from './PrototypeIcon';
import {
  HOSTING_SYSTEMS,
  HOSTING_PANELS,
  declaredHostingPanels,
} from './hosting-technology-catalogue';

/** Repères déclaratifs : aucune couleur ne prétend attester une connexion. */
export function HostingServerTechnology(
  server: Pick<HostingServerView, 'operatingSystem' | 'pleskDeclared' | 'controlPanels'> & {
    readonly provider?: ReactNode;
    readonly pleskInventory?: HostingServerView['pleskInventory'];
  },
): React.JSX.Element {
  const system = server.operatingSystem === null ? null : HOSTING_SYSTEMS[server.operatingSystem];
  const panels = declaredHostingPanels(server);
  return (
    <div className="hosting-servers__technologies">
      {server.provider !== undefined && (
        <div className="hosting-servers__technology-group">
          <small>Hébergeur</small>
          <div className="hosting-servers__provider">{server.provider}</div>
        </div>
      )}
      <div className="hosting-servers__technology-group">
        <small>OS serveur</small>
        <span className="hosting-servers__technology">
          {system ? (
            <img
              className={'hosting-servers__system-logo is-' + system.kind}
              src={system.logo}
              alt={system.name}
              width="84"
              height={system.kind === 'debian' ? 54 : 32}
            />
          ) : (
            <span>Inconnu</span>
          )}
        </span>
      </div>
      <div className="hosting-servers__technology-group">
        <small>Panneau serveur</small>
        {panels.length === 0 && <span className="hosting-servers__technology">Inconnu</span>}
        {panels.map((panel) => {
          const state =
            panel.present === true ? 'present' : panel.present === false ? 'absent' : 'unknown';
          const label =
            state === 'unknown'
              ? 'Inconnu'
              : state === 'present'
                ? 'Déclaré présent'
                : 'Déclaré absent';
          const info = HOSTING_PANELS[panel.kind];
          return (
            <span
              key={panel.kind}
              className="hosting-servers__technology"
              role="group"
              aria-label={info.name + ' ' + label.toLocaleLowerCase('fr-FR')}
            >
              <span className="hosting-servers__panel-brand">
                <img
                  className={
                    panel.kind === 'PLESK'
                      ? 'hosting-servers__plesk-logo'
                      : 'hosting-servers__panel-logo'
                  }
                  src={info.logo}
                  alt={info.name}
                  width="84"
                  height="32"
                />
                {panel.kind === 'PLESK' && server.pleskInventory && (
                  <small className="hosting-servers__panel-version">
                    {server.pleskInventory.panelVersion}
                  </small>
                )}
              </span>
              <span className={'hosting-servers__plesk-status is-' + state} title={label}>
                <span className="hosting-servers__status-icon">
                  <PrototypeIcon
                    name={state === 'present' ? 'check' : state === 'absent' ? 'x' : 'circle-help'}
                  />
                </span>
                <span>{label}</span>
              </span>
            </span>
          );
        })}
      </div>
    </div>
  );
}
